import CityAirportTemplate from '../../components/templates/CityAirportTemplate';

export default function TaxiWoerdenEindhovenAirportPage() {
  return (
    <CityAirportTemplate
      city="Woerden"
      airport="eindhoven"
      airportName="Eindhoven Airport"
      price={92.50}
      distance="82 km"
      duration="62-68 minuten"
    />
  );
}
